export const DMS_MODULE = 'Sklady';
export const CRUMB_LABEL_KEY = 'grdEdtInventuraPol';
export const NAME = 'InventuraPolozky';

export const COLUMN_STAV_FYZ = 'STAV_FYZ';
